import { ReactNode } from "react";

import { alpha, styled } from "@mui/material/styles";
import {
    LinkProps,
    ListItemText,
    ListItemButton,
    ListItemIcon,
    ListItemButtonProps,
} from "@mui/material";
// config
import { ICON, NAVBAR } from "src/config/config";

type IProps = LinkProps & ListItemButtonProps;

interface ListItemStyleProps extends IProps {
    component?: ReactNode;
    to?: string;
    activeRoot?: boolean;
    activeSub?: boolean;
    subItem?: boolean;
    isCollapse?: boolean;
}

export const ListItemStyle = styled(ListItemButton, {
    shouldForwardProp: (prop) =>
        prop !== "activeRoot" &&
        prop !== "activeSub" &&
        prop !== "subItem" &&
        prop !== "isCollapse",
})<ListItemStyleProps>(({ activeRoot, activeSub, subItem, theme, isCollapse }) => ({
    ...theme.typography.body2,
    position: "relative",
    height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
    // textTransform: "capitalize",
    textTransform: "none",
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    ...(isCollapse && {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        gap: 4,
        borderRadius: theme.shape.borderRadius,
        paddingTop: theme.spacing(1.5),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        marginRight: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5),
        height: "auto",
        "&::after": {},
    }),
    // activeRoot
    ...(activeRoot && {
        ...theme.typography.subtitle2,
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        "&::after": {
            content: "''",
            backgroundColor: theme.palette.primary.main,
            width: 3,
            height: "100%",
            borderRadius: "1px 0 0 1px",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
        },
    }),
    ...(activeRoot &&
        isCollapse && {
            "&::after": {
                display: "none",
            },
        }),
    // activeSub
    ...(activeSub && {
        ...theme.typography.subtitle2,
        color: theme.palette.text.primary,
    }),
    // subItem
    ...(subItem && {
        height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
    }),
}));

interface ListItemTextStyleProps extends ListItemButtonProps {
    isCollapse?: boolean;
}

export const ListItemTextStyle = styled(ListItemText, {
    shouldForwardProp: (prop) => prop !== "isCollapse",
})<ListItemTextStyleProps>(({ isCollapse, theme }) => ({
    whiteSpace: "nowrap",
    transition: theme.transitions.create(["width", "opacity"], {
        duration: theme.transitions.duration.shorter,
    }),
    ...(isCollapse && {
        fontSize: theme.typography.pxToRem(10),
    }),
}));

interface ListItemIconStyleProps extends ListItemButtonProps {
    isCollapse?: boolean;
    activeRoot?: boolean;
}

export const ListItemIconStyle = styled(ListItemIcon, {
    shouldForwardProp: (prop) => prop !== "isCollapse" && prop !== "activeRoot",
})<ListItemIconStyleProps>(({ isCollapse, activeRoot, theme }) => ({
    width: ICON.NAVBAR_ITEM,
    height: ICON.NAVBAR_ITEM,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(activeRoot && {
        color: theme.palette.primary.main,
    }),
    "& svg": { width: "100%", height: "100%" },
    ...(isCollapse && {
        marginRight: 0,
    }),
}));
